/**
 * Answer Vuex
 */
import * as API from '@/endpoints'
import Axios from 'axios'
import Vue from 'vue'
import _ from 'lodash'

export default {
  namespaced: true,
  state: {
    pollResult: [],
    pollAnswer: []
  },
  mutations: {
    setPollAnswer(state, v) {
      Vue.set(state, 'pollAnswer', v)
    },
    setPollResult(state, v) {
      Vue.set(state, 'pollResult', v)
    }
  },
  actions: {
    getPollResult({ commit, dispatch, state }, itemId) {
      return new Promise((resolve, reject) => {
        Axios.get(API.endpoints.item + '/' + itemId + '/result').then(
          res => {
            commit('setPollResult', res.data)
            resolve(res.data)
          },
          error => { reject(error) })
      })
    },
    getPollAnswer({ commit, dispatch, state }, itemId) {
      return new Promise((resolve, reject) => {
        Axios.get(API.endpoints.item + '/' + itemId + '/answer').then(
          res => {
            commit('setPollAnswer', res.data)
            resolve(res.data)
          },
          error => { reject(error) })
      })
    },
    postPollAnswer({ commit, dispatch, state }, { itemId, answer_id, answer }) {
      return new Promise((resolve, reject) => {
        Axios.post(API.endpoints.item + '/' + itemId + '/answer', {
          answer_id: answer_id,
          answer: answer
        }).then(
          res => { resolve(res.data) }, 
          error => { reject(error) })
      })
    }
  }
}
